import React, { useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import "./Auth.css";

const Register = () => {
  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: ""
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [checkEmail, setCheckEmail] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();
    try {
      // const response = await fetch("http://localhost:5001/api/auth/register", {
      const response = await fetch(`${process.env.REACT_APP_API_PATH}api/auth/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Registration failed");
      }
      setLoading(false);
      setCheckEmail(true);
      // Redirect to home page or dashboard
      // window.location.href = "/";
      
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        {!checkEmail && <h2>Register</h2>}
        {checkEmail && <p><b>Registration sucessfull!</b></p>}

        {!checkEmail && <>{error && <div className="error-message">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="username"
                placeholder="Username"
                value={formData.username}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>
            <button type="submit" disabled={loading} className="button gray full">Register</button>
            {loading && "Loading..."}
            <p className="auth-link">
              Already have an account? <Link to="/login">Login</Link>
            </p>
          </form></>}
        {checkEmail && <p><br />
          You have sucessfully registered. <br /><br />
          Please check your inbox to verify your email address.</p>}
      </div>
    </div>
  );
};

export default Register; 
